import XMLRDBNavigation from "./XMLRDBNavigation";
import apifetch from "../utils/apifetch";
import parseXML from "../utils/parseXML";
import FunctionValueCache from "vueforms/src/utils/FunctionValueCache"
import type { r2x } from "../index";


/**
 * Liefert zu dem XML-Dokument das XMLRDBNavigation
 */
export async function xml2Metadata(xml: XMLDocument | string): Promise<XMLRDBNavigation> {
  if (typeof xml === "string") {
    xml = parseXML(xml);
  }
  const result = await XMLRDBNavigation.getNavigation(xml);
  return result;
}

async function implFetchXML2Metadata(r2x: r2x,dataSourceName : string): Promise<XMLRDBNavigation> {
  // Bene @ Alex: 
  // Mag ja sein, dass man das auch gut in eine Zeile schreiben kann.
  // Das will ich aber nicht!
  // In den folgenden Code kann man super reindebuggen, wenn es mal ein Problem gibt.
  // Einer Codezeile mit 3 Promises ist man hilflos ausgeliefert, wenn mal was nicht stimmt.
  const url = `xmlrdb/meta/${r2x}/${dataSourceName}`;
  const fetch = await apifetch(url);
  const xmlText = await fetch.text();
  const result = await xml2Metadata(xmlText);
  return result;
}  

// Aufrufe cachen
let metadataCache = new FunctionValueCache<Promise<XMLRDBNavigation>>(implFetchXML2Metadata);

/**
  Liefert zu der Kombination r2x/dataSourceName das XMLRDBNavigation-Promise-Objekt
  Ergebnisse werden gecached
*/
 
/**
 * Liefert zu der Kombination r2x/dataSourceName das XMLRDBNavigation-Promise-Objekt
 */
export function fetchXML2Metadata(r2x: r2x,dataSourceName: string): Promise<XMLRDBNavigation> {
  return metadataCache.get(r2x,dataSourceName);
} 
/**
  Liefert zu einer Tabelle tableName das XMLRDBNavigation-Objekt
  Ergebnisse werden gecached
 */
export function fetchXML2MetadataByTable(tableName: string): Promise<XMLRDBNavigation> {  
  return metadataCache.get("R2TX",tableName);
}


